var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDecoLineTop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 664,
    height: 47,
    viewBox: "0 0 664 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_313_140786)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_313_140786)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0759 44.1046C7.2142 46.1363 1.84997 44.6866 1.45457 40.7502C1.39317 40.0956 1.49992 39.4378 1.76819 38.8176C2.03647 38.1975 2.46056 37.6282 3.01416 37.145C3.56777 36.6618 4.23909 36.2751 4.98651 36.0088C5.73392 35.7425 6.5415 35.6024 7.35918 35.597H8.08408C9.66567 35.597 11.2736 35.597 12.8552 35.597H296.553C303.987 35.597 311.196 35.3642 318.287 33.1103C323.474 31.4529 328.247 29.0584 332.376 26.0417C333.51 25.2163 331.836 23.8725 330.703 24.6978C322.782 30.4455 312.501 33.6477 301.825 33.6923C300.6 33.6923 299.387 33.6923 298.161 33.6923H11.3922C10.0742 33.6923 8.82215 33.6923 7.5437 33.6923C1.07235 33.8722 -3.40883 39.4593 0.400175 44.0729C1.03886 44.8112 1.85318 45.4408 2.79622 45.9254C3.73927 46.4099 4.79241 46.7399 5.89498 46.8963C6.99755 47.0527 8.12777 47.0324 9.22053 46.8366C10.3133 46.6408 11.347 46.2733 12.2621 45.7554C13.5801 45.0887 12.3544 43.438 11.0759 44.1046Z",
    fill: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_313_140786)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342.076 13.4176C339.654 17.9508 336.06 22.0192 331.532 25.3537C327.008 22.013 323.414 17.9416 320.988 13.407L331.532 0L342.076 13.4176Z",
    fill: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_313_140786)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.702 26.0417C339.928 32.7505 351.329 35.5652 363.652 35.5652H621.728C632.997 35.5652 644.477 35.0361 655.733 35.5652C657.256 35.5839 658.715 36.0624 659.819 36.9056C660.923 37.7487 661.591 38.8947 661.69 40.1153C661.94 44.348 656.062 46.1998 652.003 44.0729C650.685 43.4062 649.538 45.057 650.803 45.7236C651.72 46.2388 652.753 46.604 653.846 46.7983C654.938 46.9925 656.067 47.0121 657.168 46.8559C658.27 46.6996 659.323 46.3706 660.266 45.8876C661.209 45.4047 662.024 44.7772 662.665 44.0411C663.812 42.6077 664.24 40.8789 663.863 39.2024C663.487 37.5258 662.334 36.026 660.635 35.0044C658.687 33.9812 656.364 33.5187 654.046 33.6923H368.305C362.07 33.6923 355.981 33.8298 349.853 32.4754C343.345 31.0099 337.352 28.347 332.35 24.6978C331.216 23.8725 329.529 25.2163 330.676 26.0417H330.702Z",
    fill: "#1A1A1A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_313_140786",
    x: -5.00098,
    y: 24.4395,
    width: 341.755,
    height: 30.5605,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_313_140786"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_313_140786",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_313_140786",
    x: 316.988,
    y: 0,
    width: 29.0879,
    height: 33.3535,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_313_140786"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_313_140786",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_313_140786",
    x: 326.293,
    y: 24.4395,
    width: 341.704,
    height: 30.5215,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_313_140786"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_313_140786",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_313_140786"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 664,
    height: 47,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecoLineTop);
export default __webpack_public_path__ + "static/media/decoLineTop.d907e41ab2d8c0b95011f742e1458726.svg";
export { ForwardRef as ReactComponent };